import React, {useEffect} from 'react'
import {useSelector} from 'react-redux'
import {useHistory} from 'react-router-dom'
import StudentInfo from '../../components/Cards/Student/Info'
import CvCompetences from '../../components/Cards/Cv/Competences'
import CvJobs from '../../components/Cards/Cv/Jobs'
import CvLanguages from '../../components/Cards/Cv/Languages'
import CvOthers from '../../components/Cards/Cv/Others'
import CvQualifications from '../../components/Cards/Cv/Qualifications'
import {RadarChart} from '../../components/CommonComponents'
import {selectSelectedFollower} from '../../slices/selected'
import {ROUTES} from '../../db/models/const'

export const CompanyRmFollower = () => {
    const follower = useSelector(selectSelectedFollower);
    const student = follower?.user;
    const cv = follower?.cv;
    const softSkills = cv?.softSkills;
    const history = useHistory();

    useEffect(() => {
        document.body.scrollIntoView();
    }, [])

    useEffect(() => {
        if (!follower) {
            history.push(ROUTES.ME);
            return;
        }
    }, [follower]);

    return (
        <div className="companyRmFollower">
            <StudentInfo student={student} download={true}/>
            <div className="card companyRmFollower__radar">
                <RadarChart softSkills={softSkills} onClick={() => {
                }}/>
            </div>
            <CvQualifications qualifications={Object.values(cv?.bg?.qualifications || {})}/>
            <CvJobs jobs={Object.values(cv?.bg?.jobs || {})}/>
            <CvLanguages languages={Object.values(cv?.bg?.languages || {})}/>
            <CvCompetences competences={Object.values(cv?.bg?.competences || {})}/>
            <CvOthers others={Object.values(cv?.bg?.others || {})}/>
            {/* <h2 className="sectionHeader">Games Partecipati</h2>
            <div className="row games">
                {games.map((game) => (
                    <CardRmGameBrief key={game.id} game={game} editable={false} />
                ))}
            </div> */}
            {/* <PDFViewer width="1000" height="1000">
                <FollowerPDF follower={follower} />
            </PDFViewer> */}
        </div>
    )
}
